import { render } from "./CustomFileUpload.vue?vue&type=template&id=61d7b20a&scoped=true"
import script from "./CustomFileUpload.vue?vue&type=script&lang=js"
export * from "./CustomFileUpload.vue?vue&type=script&lang=js"

import "./CustomFileUpload.vue?vue&type=style&index=0&id=61d7b20a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d7b20a"]])

export default __exports__